import { Button } from "@/components/shadcn/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/shadcn/dialog";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
interface Props {
    isOpen: boolean;
}
export const SerieVideoPremiumWarningModal = ({ isOpen }: Props) => {
    const t = useTranslations("series");
    const router = useRouter();
    const [modalToggle, setModalToggle] = useState<boolean>(isOpen);
    useEffect(() => {
        setModalToggle(isOpen);
    }, [isOpen]);
    return (
        <Dialog open={modalToggle} onOpenChange={setModalToggle}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle className="w-full text-center">
                        {t("premiumWarning")}
                    </DialogTitle>
                    <DialogDescription className="w-full text-center">
                        Satranç365 Premium üyeliği ile tüm videoları
                        izleyebilirsiniz.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button
                        type="submit"
                        onClick={() => {
                            setModalToggle(false);
                            router.push("/premium");
                        }}
                    >
                        {t("premiumMembership")}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
